module.exports = __webpack_public_path__ + "img/active-layer5.5f7764f3.png";